import React, { useRef } from 'react'
import { useReactToPrint } from 'react-to-print'

import { format } from '../../utils/number'
import Button from '../../components/common/Button'
import { getCurrency, getMeasurement, getTradeTypeName } from '../../utils/types'
import { CustomCheckPrint } from '../../components/customs/check-print'

export default function Confirmation({ onCancel, onConfirm, values, totals, loading, cash }) {
    const componentRef = useRef()
    const handlePrint = useReactToPrint({ content: () => componentRef.current })
    const getPrice = (product) => {
        if (values.currency === 'sum') {
            return values.tradeType === 'wholesale' ? product?.sumPriceTransfer : product?.sumPriceSale
        }
        return values.tradeType === 'wholesale' ? product?.usdPriceTransfer : product?.usdPriceSale
    }
    return (
        <>
            {values?.client && (
                <p style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
                    <b>Клиент:</b>
                    <span style={{ fontWeight: 500 }}>{values.client?.name}</span>
                </p>
            )}

            <p style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
                <b>Тип торговли:</b>
                <span style={{ fontWeight: 500 }}>{getTradeTypeName(values.tradeType)}</span>
            </p>

            <p style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
                <b>Валюта:</b>
                <span style={{ fontWeight: 500 }}>{getCurrency(values.currency)}</span>
            </p>

            <p style={{ fontWeight: 'bold' }}>Продукты:</p>

            <div style={{ height: 1, backgroundColor: 'black', margin: '8px 0' }} />

            {values?.products?.map((prod, i) => {
                const price = getPrice(prod)
                return (
                    <div key={prod?.id} style={{ marginBottom: '1rem' }}>
                        <h3 style={{ fontWeight: 'bold' }}>
                            {i + 1}. {prod?.name}
                        </h3>

                        <p style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
                            <span>Цена:</span>
                            <span style={{ fontWeight: 500 }}>
                                {prod?.quantity} {getMeasurement(prod?.measurement)} x {format(price) || 0}{' '}
                                {values.currency === 'sum' ? 'Cyм' : 'USD'} ={' '}
                                <b>
                                    {format(prod?.quantity * price)} {values.currency === 'sum' ? 'Cyм' : 'USD'}
                                </b>
                            </span>
                        </p>
                    </div>
                )
            })}
            <div style={{ height: 1, backgroundColor: 'black', margin: '8px 0' }} />
            <p style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
                <span style={{ fontWeight: 'bold' }}>Итого:</span>
                <b>
                    {format(totals.totalSaleSum)} {values.currency === 'sum' ? 'Сум' : 'USD'}
                </b>
            </p>
            <div style={{ display: 'none' }}>
                <CustomCheckPrint paidAmount={values.item.sumComing} lend={values.item.amount - values.item.sumComing}
                    result={values.item.amount}
                    item={values} ref={componentRef} />

            </div>
            <div style={{ marginTop: '1rem', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <Button
                    onClick={() => {
                        onConfirm()
                        handlePrint()
                    }}
                    text="Подтвердить"
                    className="is-primary"
                    loading={cash.loading}
                    disabled={loading}
                />
                <Button onClick={onCancel} text="Отмена" className="is-outlined" disabled={loading} />
            </div>
        </>
    )
}
